// extracted by mini-css-extract-plugin
export default {"sec1":"Unge_sec1__4GSwJ","sec2":"Unge_sec2__UmKqJ","gallery":"Unge_gallery__eSp9Y"};